export enum RulesType {
  Conditions = 'conditions',
  EditChecks = 'editChecks',
}
